import { Map as ImmMap } from 'immutable';
import SnackBarSettings from './SnackbarSettings';
import { DISABLE_NOTIFICATION, SHOW_NOTIFICATION } from './constants';

export const initialState = new ImmMap({
	notification: new SnackBarSettings(),
});

const notificationReducer = (state = initialState, action) => {
	switch (action.type) {
		case DISABLE_NOTIFICATION:
			return state.set('notification', new SnackBarSettings());
		case SHOW_NOTIFICATION: {
			const settings = Object.assign(new SnackBarSettings(), action.settings);
			return state.set('notification', settings);
		}
		default:
			return state;
	}
};

export default notificationReducer;
